import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaTimes, FaTerminal, FaGlobe, FaBookDead, FaMicrochip, FaLock, FaUserCircle, FaRocket, FaBars, FaArrowLeft } from "react-icons/fa";
import "../../kaipedia/kaipedia.css";
import { demoBlogs } from "../../../../components/DemoKaipedia";
import MusicPlayer from "../../../../components/MusicPlayer";
const authors = [
    { name: "System_K31", posts: 4, status: "Offline" },
];

const sidebarItems = [
    { 
        title: "Penetration Testing", 
        category: "CYBERSECURITY", 
        subtitle: "Kali Linux Advanced Tools", 
        image: "/K_1.png", 
        Url: "https://www.kali.org/",
    },
    { 
        title: "Security OS", 
        category: "CYBERSECURITY", 
        subtitle: "Parrot Security OS", 
        image: "/K_1.png", 
        Url: "https://parrotsec.org/",
    },
    { 
        title: "Nature Journal", 
        category: "SCIENCE & RESEARCH", 
        subtitle: "Journal of Science", 
        image: "/K_1.png", 
        Url: "https://www.nature.com/",
    },
];

const BlogDetailPage: React.FC = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const blog = demoBlogs.find((b) => b.id === Number(id));

    const triggerLockToast = () => {
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
    };

    if (!blog) return <div className="min-h-screen bg-[#050b18] flex items-center justify-center text-cyan-500 font-mono uppercase">Log_Not_Found</div>;


    const RightContent = () => (
        <div className="space-y-8 mt-10">
            <section>
                <h4 className="text-[10px] font-black text-blue-400 uppercase tracking-[0.3em] mb-5 flex items-center gap-3">
                    <span className="w-4 h-[1px] bg-cyan-500"></span> Recommendation
                </h4>
                <div className="space-y-3">
                    {sidebarItems.map((item, idx) => (
                        <a href={item.Url} target="" key={idx} className="group cursor-pointer flex gap-3 p-2 rounded-xl hover:bg-white/5 transition-all">
                            <div className="w-10 h-10 shrink-0 border border-cyan-500/20 rounded-lg overflow-hidden">
                                <img src={item.image} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all" alt="" />
                            </div>
                            <div className="min-w-0">
                                <p className="text-[7px] text-cyan-500 font-bold uppercase">{item.category}</p>
                                <a className="text-[10px] font-black text-white group-hover:text-cyan-400 truncate uppercase">{item.title}</a>
                                <p className="text-[8px] text-slate-500 italic font-mono uppercase tracking-tighter">{item.subtitle}</p>
                            </div>
                        </a>
                    ))}
                </div>
            </section>
        </div>
    );

    return (
        <> 
            <div className="starry-bg min-h-screen bg-[#050b18] text-slate-200 font-sans flex justify-center overflow-hidden selection:bg-cyan-500/30">
                
                <div className={`fixed inset-0 z-[100] lg:hidden transition-all duration-300 ${isMenuOpen ? "visible" : "invisible"}`}>
                    <div className={`absolute inset-0 bg-slate-950/90 backdrop-blur-md transition-opacity ${isMenuOpen ? "opacity-100" : "opacity-0"}`} onClick={() => setIsMenuOpen(false)} />
                    <aside 
                        className={`absolute inset-y-0 left-0 w-72 bg-[#0a1628] border-r border-cyan-500/30 p-6 
                        transform transition-transform duration-300 flex flex-col
                        ${isMenuOpen ? "translate-x-0" : "-translate-x-full"}`}
                    >
                        <div className="flex justify-between items-center mb-8 shrink-0">
                            <h2 className="text-sm font-black text-cyan-400 tracking-widest uppercase italic">
                                System_Menu
                            </h2>
                            <FaTimes 
                                className="text-cyan-400 cursor-pointer hover:rotate-90 transition-transform" 
                                onClick={() => setIsMenuOpen(false)} 
                            />
                        </div>

                        <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar">
                            <div className="mt-1 pb-10">
                                <div className="mt-1">
                                    <MusicPlayer mobile />
                                </div>
                            </div>
                        </div>
                    </aside>
                </div>

                <main className="flex-1 max-w-2xl xl:max-w-3xl flex flex-col h-screen overflow-y-auto border-x border-cyan-500/10 bg-slate-900/[0.05] backdrop-blur-3xl custom-scrollbar z-10 lg:mx-[18rem]">
                    
                    <header className="sticky top-0 z-50 bg-[#0a1628]/95 backdrop-blur-xl border-b-2 border-cyan-400/50 shadow-[0_10px_30px_-10px_rgba(6,182,212,0.4)] px-4 sm:px-8 py-4 sm:py-6">
                        <div className="grid grid-cols-3 items-center">
                            <div className="flex justify-start">
                                <button 
                                    onClick={() => navigate(-1)}
                                    className="flex items-center justify-center gap-2 px-3 sm:px-5 py-2 sm:py-2.5 
                                            bg-cyan-500/5 border border-cyan-500/30 text-cyan-400 
                                            text-[9px] sm:text-[10px] font-black uppercase rounded-lg sm:rounded-xl 
                                            hover:bg-cyan-500 hover:text-[#050b18] hover:shadow-[0_0_15px_rgba(6,182,212,0.5)]
                                            active:scale-95 transition-all group"
                                >
                                    <FaArrowLeft className="group-hover:-translate-x-1 transition-transform" size={10} />
                                    <span className="hidden sm:inline">Back_To_Board</span>
                                    <span className="sm:hidden text-[8px]">BACK</span>
                                </button>
                            </div>
                            <div className="flex flex-col items-center text-center min-w-0">
                                <h2 className="text-sm sm:text-xl font-black text-white tracking-widest uppercase italic leading-none truncate w-full">
                                    LOG<span className="text-cyan-500">_VIEWER</span>
                                </h2>
                                <p className="hidden xs:block text-[7px] sm:text-[8px] font-mono text-slate-500 uppercase mt-1 truncate w-full">
                                    File: {blog.title.replace(/\s+/g, '_')}.dat
                                </p>
                            </div>

                            <div className="flex justify-end">
                                <button 
                                    onClick={() => setIsMenuOpen(true)} 
                                    className="lg:hidden p-2 text-cyan-400 hover:bg-cyan-500/10 rounded-lg transition-colors shrink-0"
                                    aria-label="Open Menu"
                                >
                                    <FaBars size={20} />
                                </button>
                                
                                <div className="hidden lg:flex items-center gap-2">
                                    <div className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse shadow-[0_0_8px_#22d3ee]"></div>
                                    <span className="text-[8px] font-mono text-cyan-400 uppercase tracking-tighter">System_Active</span>
                                </div>
                            </div>

                        </div>
                    </header>

                    <div className="p-4 sm:p-8 pb-32 pt-10">
                        <article className="bg-[#0a1628]/40 border border-cyan-500/10 rounded-[2.5rem] overflow-hidden">
                            <div className="aspect-video relative overflow-hidden border-b border-cyan-500/10">
                                <img src={blog.image} className="w-full h-full object-cover opacity-80" alt="" />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] to-transparent"></div>
                                <div className="absolute bottom-6 left-8">
                                    <span className="px-3 py-1 bg-cyan-600 text-white text-[9px] font-black uppercase tracking-widest rounded-md mb-2 inline-block">
                                        {blog.category}
                                    </span>
                                    <h1 className="text-2xl sm:text-3xl font-black text-white uppercase leading-tight drop-shadow-lg">
                                        {blog.title}
                                    </h1>
                                </div>
                            </div>

                            <div className="p-8 sm:p-10 font-sans text-slate-300">
                                <div className="flex items-center gap-4 mb-10 pb-6 border-b border-cyan-500/5">
                                    <div className="text-[10px] font-mono text-cyan-600 uppercase">
                                        <span className="text-slate-500">Date:</span> {blog.date}
                                    </div>
                                    <div className="text-[10px] font-mono text-cyan-600 uppercase">
                                        <span className="text-slate-500">Access:</span> Restricted
                                    </div>
                                    <div className="flex items-center gap-2 text-[10px] text-cyan-400/60 font-mono">
                            <FaMicrochip size={10} /> Author : {blog.author}
                        </div>
                                </div>

                                <div className="space-y-6 text-sm sm:text-base leading-relaxed text-justify blog-content">
                                    {blog.content.map((block, i) => (
                                        <React.Fragment key={i}>{block}</React.Fragment>
                                    ))}
                                </div>

                                {/* Footer Log */}
                                <div className="mt-16 p-6 bg-cyan-500/5 border border-cyan-500/10 rounded-2xl">
                                    <div className="flex justify-between items-center mb-4">
                                        <p className="text-[10px] font-mono text-cyan-700 uppercase tracking-widest">End_Of_File</p>
                                        <FaTerminal className="text-cyan-900" size={12} />
                                    </div>
                                    <button onClick={() => navigate(-1)} className="w-full py-3 bg-cyan-600/10 border border-cyan-500/20 text-cyan-400 text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-cyan-500 hover:text-[#050b18] transition-all flex items-center justify-center gap-2">
                                        Back To KaiPedia <FaRocket />
                                    </button>
                                </div>
                            </div>
                        </article>
                    </div>
                </main>

                <aside className="hidden lg:flex fixed right-0 inset-y-0 w-80 border-l border-cyan-500/10 p-8 flex-col gap-10 bg-[#050b18] z-20 overflow-y-auto no-scrollbar">
                    <RightContent />
                    
                    <div className="bg-gradient-to-br from-[#0a1628] to-blue-950/40 border border-cyan-500/20 p-6 rounded-[2rem] mt-auto">
                        <h4 className="text-[10px] font-black text-cyan-400 uppercase mb-3 flex items-center gap-2">
                            <FaTerminal size={12} /> Terminal_Output
                        </h4>
                        <p className="text-[10px] font-mono text-slate-500 italic">"Reading: {blog.title}"</p>
                        <div className="mt-4 flex justify-between items-center text-[9px] font-bold text-cyan-900 uppercase">
                            <span>© 2026 KAILOG</span>
                            <FaGlobe className="animate-spin-slow" />
                        </div>
                    </div>
                </aside>

            </div>

            <div className={`fixed top-10 left-1/2 -translate-x-1/2 z-[200] transition-all duration-500 transform ${showToast ? "translate-y-0 opacity-100" : "-translate-y-20 opacity-0 pointer-events-none"}`}>
                <div className="bg-[#0a1628]/95 backdrop-blur-md border-2 border-red-500 shadow-[0_0_25px_rgba(239,68,68,0.3)] rounded-2xl px-6 py-4 flex items-center gap-4 min-w-[320px] overflow-hidden">             
                    <div className="w-10 h-10 bg-red-500/20 rounded-full flex items-center justify-center border border-red-500/50 shrink-0">
                        <FaLock className="text-red-500 animate-pulse" size={16} />
                    </div>
            
                    <div className="flex-1">
                        <h5 className="text-red-500 text-[11px] font-black uppercase tracking-[0.2em] flex items-center gap-2">
                            <span className="w-2 h-2 bg-red-500 rounded-full animate-ping"></span>
                            Access_Denied
                        </h5>
                        <p className="text-slate-400 text-[9px] font-mono leading-tight mt-1 uppercase">
                            ERROR_403: AUTH_REQUIRED<br/>
                            <span className="text-red-400/60 tracking-tighter italic">"Log_File_Is_Encrypted"</span>
                        </p>
                    </div>
            
                    <button onClick={() => setShowToast(false)} className="text-slate-600 hover:text-white transition-colors">
                        <FaTimes size={12} />
                    </button>

                    <div className="absolute bottom-0 left-0 h-[3px] bg-red-600 transition-all duration-[3000ms] ease-linear" 
                        style={{ width: showToast ? '0%' : '100%', transitionDuration: showToast ? '3000ms' : '0ms' }}>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogDetailPage;